import { SystemHealthOutageDto } from '../types/system-health-api.types';
import { ComponentView } from '../types/system-health.types';

export interface SystemHealthHistoryState {
  items: SystemHealthOutageDto[];
  monitoringGaps: SystemHealthOutageDto[];
}

export interface SystemHealthState {
  components: ComponentView[];
  generatedAt: number;
  lastFetchedAt: number;
  nextRefreshAt: number;
  consecutiveFailures: number;
  hasLoaded: boolean;
  /** The 1 s tick, for labels that must age between refreshes ("2 min ago" → "3 min ago"). */
  now: number;
  /** Raw history, so the report can be re-derived when the clock or the copy changes. */
  history: SystemHealthHistoryState;
  /** History needs the detail key; on the public view the section is simply absent. */
  hasReport: boolean;
  /** True while the last history fetch failed — the section stays, with a "temporarily unavailable" note. */
  isReportUnavailable: boolean;
  /** True when the window held more outages than one page carries, so the report is a partial view. */
  isReportTruncated: boolean;
  hasAuthError: boolean;
}

export const initialSystemHealthState: SystemHealthState = {
  components: [],
  generatedAt: 0,
  lastFetchedAt: 0,
  nextRefreshAt: 0,
  consecutiveFailures: 0,
  hasLoaded: false,
  now: Date.now(),
  history: { items: [], monitoringGaps: [] },
  hasReport: false,
  isReportUnavailable: false,
  isReportTruncated: false,
  hasAuthError: false,
};
